import React, { FC } from 'react';
import classnames from 'classnames';
import styles from './small_chip.module.scss';

type Props = {
  color?: 'warning' | 'primary' | 'secondary';
  className?: string;
};

export const SmallChip: FC<Props> = ({
  children,
  color = 'warning',
  className,
}) => (
  <span
    className={classnames(styles.chip, className, {
      [styles.warning]: color === 'warning',
      [styles.primary]: color === 'primary',
      [styles.secondary]: color === 'secondary',
    })}
  >
    {children}
  </span>
);
